import { BdkTabItem } from '@breuni-ui/bdk-tabs';
import { safeDefine } from '@breuni-ui/safe-define';

// empty by intention
class EntsTabItem extends BdkTabItem {}

safeDefine('ents-tab-item', EntsTabItem);
